import { useLoaderData } from "@tanstack/react-router";
import { Mail, Shield, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import ProfileContentSection from "@/components/profile-content-section";

export default function Profile() {
  const { email, sub } = useLoaderData({ from: "/_root" });

  return (
    <ProfileContentSection title="Profile" desc="Manage your profile settings.">
      <Card
        className={cn(
          "relative overflow-hidden rounded-lg shadow-sm",
          "bg-gradient-to-br from-blue-50 to-green-50 dark:from-gray-800 dark:to-gray-900",
          "before:pointer-events-none before:absolute before:inset-0 before:content-['']",
        )}
      >
        <div className="absolute right-2 top-2 z-10">
          <Badge
            className={cn(
              "relative overflow-hidden rounded-full px-3 py-1 font-bold text-white shadow-lg",
              "bg-gradient-to-r from-yellow-400 to-yellow-500 dark:from-yellow-500 dark:to-yellow-600",
              "before:animate-shimmer before:pointer-events-none before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent",
              "flex items-center gap-2",
            )}
          >
            <Shield className="h-4 w-4 text-white" />
            Super Admin
          </Badge>
        </div>

        <CardHeader>
          <CardTitle className="text-xl font-bold text-gray-700 dark:text-gray-100">
            Account Information
          </CardTitle>
        </CardHeader>

        <CardContent className="grid gap-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-gray-600 dark:text-gray-300" />
              <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                Role
              </span>
            </div>
            <Badge
              variant="secondary"
              className="border border-green-200 bg-green-100 text-green-700 dark:border-green-700 dark:bg-green-900 dark:text-green-100"
            >
              Superadmin
            </Badge>
          </div>

          <Separator className="opacity-20" />

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-gray-600 dark:text-gray-300" />
              <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                Email Address
              </span>
            </div>
            <span className="text-sm text-gray-600 dark:text-gray-300">
              {email}
            </span>
          </div>

          <Separator className="opacity-20" />

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <User className="h-4 w-4 text-gray-600 dark:text-gray-300" />
              <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                User ID
              </span>
            </div>
            <span className="text-sm text-gray-600 dark:text-gray-300">
              {sub}
            </span>
          </div>
        </CardContent>
      </Card>
    </ProfileContentSection>
  );
}
